export default {
  gql: {
    GET_GROUP_LESSONS: `
      query groupLessons(
        $filter: LessonFilterInput,
        $sort: [LessonSortInput!]
      ) {
        groupLessons(
          filter: $filter,
          sort: $sort
        ) {
          items {
            id
            name
            price
            startsAt
            endsAt
            attendeeCount
            slotCount
            headCoach {
              id
              firstName
              lastName
              color
            }
            coachSlots {
              id
              coachId
              coach {
                firstName
                lastName
                description
                color
              }
              startsAt
              endsAt
              duration
              endsAtIncludingBreak
              status
            }
            type
            ... on GroupLesson {
              description
              ageCalculator
              minAge
              maxAge
              minGroupSize
              maxGroupSize
              waitingListSize
              createdAt
              skillLevels {
                id
                name
                rank
                description
              }
            }
            status
          }
          totalCount
        }
      }
    `,
    GET_LESSON: `
      query lesson($id: ID!) {
        lesson(id: $id) {
          id
          name
          price
          startsAt
          endsAt
          attendeeCount
          slotCount
          headCoach {
            id
            firstName
            lastName
            color
          }
          coachSlots {
            id
            coachId
            coach {
              firstName
              lastName
              description
              color
            }
            startsAt
            endsAt
            duration
            endsAtIncludingBreak
            status
          }
          type
          ... on GroupLesson {
            description
            ageCalculator
            minAge
            maxAge
            minGroupSize
            maxGroupSize
            waitingListSize
            createdAt
            skillLevels {
              id
              name
              rank
              description
            }
          }
          status
        }
      }
    `,
    GET_LESSON_REGISTRATIONS: `
      query lessonRegistrations($lessonId: ID!) {
        lessonRegistrations(lessonId: $lessonId) {
          customer {
            id
            pgbTid
            lastName
            firstName
          }
          price
          status
          paymentStatus
          createdAt
        }
      }
    `,
    GET_COACHS: `
      query coachs {
        coachs {
          items {
            id
            firstName
            lastName
            description
            color
            createdAt
          }
          totalCount
        }
      }
    `,
    GET_COACH_AVAILABILITY_TIMES: `
      query coachAvailableTimes(
        $duration: Int!,
        $date: LocalDate!,
        $coachIds: [ID!]!
      ) {
        coachAvailableTimes(
          duration: $duration,
          date: $date,
          coachIds: $coachIds
        ) {
          coach {
            id
            firstName
            lastName
            description
            color
            createdAt
          }
          price
          availableTimes
        }
      }
    `,
    GET_SKILL_LEVELS: `
      query skillLevels {
        skillLevels {
          items {
            id
            name
            description
            rank
            lowestLevel
            highestLevel
            createdAt
          }
          totalCount
        }
      }
    `,
    GET_CUSTOMERS_FROM_PGB: `
      query customersFromPgb(
        $search: String!,
        $limit: Int
      ) {
        customersFromPgb(
          search: $search,
          limit: $limit
        ) {
          items {
            id
            pgbTid
            lastName
            firstName
            email
          }
          limit
          totalCount
        }
      }
    `,
    GET_MY_LESSON_REGISTRATIONS: `
      query myLessonRegistrations(
        $filter: LessonRegistrationFilterInput,
        $sort: [LessonRegistrationSortInput],
        $offset: Int,
        $limit: Int
      ) {
        myLessonRegistrations(
          filter: $filter,
          sort: $sort,
          offset: $offset,
          limit: $limit
        ) {
          items {
            id
            lessonId
            source
            lesson {
              id
              name
              type
              price
              startsAt
              endsAt
              attendeeCount
              slotCount
              headCoach {
                id
                firstName
                lastName
                color
              }
              coachSlots {
                id
                coachId
                coach {
                  firstName
                  lastName
                  description
                  color
                }
                startsAt
                endsAt
                duration
                endsAtIncludingBreak
                status
              }
              status
            }
            status
            customerId
            customer {
              id
              pgbTid
              firstName
              lastName
            }
            price
            status
            paymentStatus
            createdAt
          }
          limit
          offset
          totalCount
        }
      }
    `,
    GET_MY_LESSON_PARTNERS: `
      query myLessonPartners($lessonId: ID!) {
        myLessonPartners(lessonId: $lessonId) {
          lessonId
          lesson {
            id
            type
            headCoach {
              id
              firstName
              lastName
              color
            }
            name
            access
            status
            startsAt
            endsAt
            price
            slotCount
            attendeeCount
            coachSlots {
              id
              coachId
              coach {
                firstName
                lastName
                description
                color
              }
              startsAt
              endsAt
              duration
              endsAtIncludingBreak
              status
            }
            createdAt
            cancellation {
              canceledAt
              comment
              reason
            }
            product {
              code
              name
              price
            }
          }
          customerId
          customer {
            id
            pgbTid
            lastName
            firstName
            phone
            email
            gender
            dateOfBirth
          }
          price
          status
          paymentStatus
          createdAt
        }
      }
    `,
    GROUP_LESSON_BOOK: `
      mutation groupLessonBook($input: GroupLessonBookInput!) {
        groupLessonBook(input: $input) {
          lesson {
            id
            type
            headCoach {
              id
              firstName
              lastName
              color
            }
            name
            access
            status
            startsAt
            endsAt
            price
            slotCount
            attendeeCount
            coachSlots {
              id
              coachId
              coach {
                firstName
                lastName
                description
                color
              }
              startsAt
              endsAt
              duration
              endsAtIncludingBreak
              status
            }
            createdAt
            cancellation {
              canceledAt
              comment
              reason
            }
            product {
              code
              name
              price
            }
            skillLevels {
              id
              name
              description
            }
            description
            ageCalculator
            minAge
            maxAge
            minGroupSize
            maxGroupSize
            waitingListSize
          }
        }
      }
    `,
    INDIVIDUAL_LESSON_BOOK: `
      mutation individualLessonBook($input: IndividualLessonBookInput!) {
        individualLessonBook(input: $input) {
          lesson {
            id
            type
            headCoach {
              id
              firstName
              lastName
              color
            }
            name
            access
            status
            startsAt
            endsAt
            price
            slotCount
            attendeeCount
            coachSlots {
              id
              coachId
              coach {
                firstName
                lastName
                description
                color
              }
              startsAt
              endsAt
              duration
              endsAtIncludingBreak
              status
            }
            createdAt
            cancellation {
              canceledAt
              comment
              reason
            }
            product {
              code
              name
              price
            }
          }
        }
      }
    `,
    INDIVIDUAL_LESSON_CANCEL: `
      mutation individualLessonCancel($input: IndividualLessonCancelInput!) {
        individualLessonCancel(input: $input)
      }
    `,
    LESSON_REGISTRATION_BATCH_CANCEL: `
      mutation lessonRegistrationBatchCancel($input: LessonRegistrationBatchCancelInput!) {
        lessonRegistrationBatchCancel(input: $input)
      }
    `,
    LESSON_REGISTRATION_QUOTAS: `
      query lessonRegistrationQuota(
        $customerId: ID!,
        $lessonType: LessonType!
      ) {
        lessonRegistrationQuota(
          customerId: $customerId,
          lessonType: $lessonType
        ) {
          quota
          isExceeded
        }
      }
    `,
  },
};
